import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { Address } from '../../../../types/api/clients';
import { getAddressSchema } from '../../../validations/address';

export type FormCode = {
  code: string;
};

export type FormFields = FormCode & Address;

export const RESOLVED_STATUSES = [
  'RESOLVED_BY_ORDERER',
  'RESOLVED_BY_SENDER',
  'RESOLVED_BY_RECIPIENT',
  'RESOLVED_BY_EMPLOYEE',
];

export function isResolvedStatus(status?: string): boolean {
  return !!status && RESOLVED_STATUSES.includes(status);
}

export function getResolverLabelKey(status?: string): string {
  switch (status) {
    case 'RESOLVED_BY_ORDERER':
      return 'the orderer';
    case 'RESOLVED_BY_SENDER':
      return 'the sender';
    case 'RESOLVED_BY_RECIPIENT':
      return 'the recipient';
    case 'RESOLVED_BY_EMPLOYEE':
      return 'an employee';
    default:
      return '';
  }
}

export function getDefaultValues(code: string, data?: any) {
  const source = data?.resolvedAddress ?? data?.address;
  const resolved = data?.resolvedAddress;

  return {
    code,
    municipalityId:
      source?.municipalityId != null ? String(source.municipalityId) : null,
    municipalityName: source?.municipalityName ?? '',
    placeId: source?.placeId != null ? String(source.placeId) : null,
    placeName: source?.placeName ?? '',
    streetId: resolved?.streetId != null ? String(resolved.streetId) : null,
    streetName: resolved?.streetName ?? '',
    housenumber: resolved?.housenumber ?? '',
    entrance: resolved?.entrance ?? '',
    apartment: resolved?.apartment ?? '',
    rawName: resolved?.rawName ?? '',
    postcode: resolved?.postcode ?? '',
  };
}

export function getValidationSchema(t: TFunction): Yup.AnyObjectSchema {
  return Yup.object().shape({
    code: Yup.string(),
    ...getAddressSchema(t, { municipality: true }).fields,
  });
}
